<template>
  <div id="validacion-registra">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Datos contingencia</v-toolbar-title
              >
            </v-toolbar>
            <v-form>
              <v-container>
                <v-layout>
                  <v-flex>
                    <!-- INICIO DATOS DE VISITA PADRE -->
                    <data-contingencia
                      v-if="tipeView != 'consulta'"
                      :id="id"
                      :tipeView="tipeView"
                    ></data-contingencia>
                    <!-- TERMINO DATOS DE VISITA -->
                  </v-flex>
                </v-layout>
              </v-container>
              <v-container>
                <v-layout>
                  <v-flex>
                    <!-- INICIO DATOS DE VISITA PADRE -->
                    <grid-estado
                      v-if="tipeView == 'crear' ? false : true"
                      :id="id"
                      :tipeView="tipeView"
                    ></grid-estado>
                    <!-- TERMINO DATOS DE VISITA -->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import GridEstado from "@/modules/impresion/views/contingencia/GridEstados.vue";
import DataContingencia from "@/modules/impresion/views/contingencia/ContingenciaData.vue";
import axios from "axios";

export default {
  name: "contingencia-registra",
  components: {
    DataContingencia,
    GridEstado,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipo: "",
  },

  data: () => ({
    id: "",
    documentoId: "",
    tipeView: "",
  }),

  computed: {},
  mounted() {},
  created() {
    this.id = this.$route.params.id;
    this.tipeView = this.$route.params.tipeView;
  },

  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
